import EntityInterface from '../interfaces/Entity';

export default class Group implements EntityInterface {
  public ['@id']!: string;
  public id!: number;
  public organizationId!: number;
  public name!: string;
  public logoRemotePath!: string;

  constructor(data?: Partial<Group>) {
    Object.assign(this, data);
  }

  toApi(): Record<string, unknown> {
    const data = { ...this } as Record<string, unknown>;
    return data;
  }
}
